import './style.css';
import { ConnectFourApp } from './ui/app';

const root = document.getElementById('app');
if (!root) throw new Error('Root element #app not found.');

new ConnectFourApp(root);
